module.exports = __webpack_public_path__ + "img/expansion-panel-info.168ce108.gif";